module.exports = __webpack_public_path__ + "img/DefaultPhotoGirl.404682de.png";